import { SECTION_TYPES } from "@/lib/constants/sections";
import { MapPin } from "lucide-react";

const serviceAreaMapSection = {
  type: SECTION_TYPES.SERVICE_AREA_MAP,
  content: {},
  meta: {
    displayName: "Service Area Map",
    displayDescription: "Show your customers where you operate in a map.",
    displayIcon: MapPin,
  },
};

export default serviceAreaMapSection;
